module.exports = __webpack_public_path__ + "static/media/main.a2698892.png";